import { render } from "./CreateNewWebsiteEvents.vue?vue&type=template&id=35adbc82&scoped=true"
import script from "./CreateNewWebsiteEvents.vue?vue&type=script&lang=js"
export * from "./CreateNewWebsiteEvents.vue?vue&type=script&lang=js"

import "./CreateNewWebsiteEvents.vue?vue&type=style&index=0&id=35adbc82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35adbc82"]])

export default __exports__